export default __webpack_public_path__ + "static/media/Amazon.85fecb78.jpg";